import React from 'react'
import Pt from 'prop-types'
import Ipt from 'react-immutable-proptypes'

import {
  PaymentTokenRecord,
} from '../../records'
import SquareCardForm from './SquareCardForm'
import TokenSelector from './TokenSelector'

export default function PaymentMethod({
  allowNewCard,
  errors,
  selectedToken,
  selectToken,
  setClear,
  setTokenise,
  showWhenEmpty,
  tokens,
}) {
  return (
    <div className="payment-method">
      <TokenSelector
        allowNewCard={allowNewCard}
        errors={errors}
        selectedToken={selectedToken}
        selectToken={selectToken}
        showWhenEmpty={showWhenEmpty}
        tokens={tokens}
      />

      {(allowNewCard && !selectedToken) && (
        <SquareCardForm
          setClear={setClear}
          setTokenise={setTokenise}
          errors={errors}
          disabled={false}
        />
      )}
    </div>
  )
}

PaymentMethod.propTypes = {
  allowNewCard: Pt.bool,
  bsSize: Pt.string,
  errors: Ipt.map.isRequired,
  selectedToken: Pt.string,
  selectToken: Pt.func.isRequired,
  setClear: Pt.func.isRequired,
  setTokenise: Pt.func.isRequired,
  showWhenEmpty: Pt.bool,
  tokens: Ipt.orderedSetOf(PaymentTokenRecord).isRequired,
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/components/Payment/Method.jsx